<template>
    <div class="tit-wrap text-center">
        <h4 v-if="this.$slots['default']" class="tit tit--lg font-weight-regular" data-aos="fade-up" data-aos-delay="100"><slot /></h4>
        <p v-if="this.$slots['text']" class="txt txt--lg" data-aos="fade-up" data-aos-delay="200">
            <slot name="text" />
        </p>
    </div>
</template>

<script>
export default {
    props: {
    },
    components: {},
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
